jQuery(function ($) {
  function getHeaderHeight() {
      return $(".l-header-container").outerHeight() || 0;
  }

  $(".c-anchor-links__link a").on("click", function (event) {
      event.preventDefault();
      
      let target = $(this.getAttribute("href"));
      if (target.length) {
          let headerHeight = getHeaderHeight();
          $("html, body").animate({
              scrollTop: target.offset().top - headerHeight - 60
          }, 200);
      }
  });

  $(window).on("resize", function () {
      getHeaderHeight();
  });
});

jQuery(function ($) {
  function getHeaderHeight() {
      return $(".l-header-container").outerHeight() || 0;
  }

  $(".l-footer__accordion-content a").on("click", function (event) {
      let target = $(this.getAttribute("href"));
      if (target.length) {
          let headerHeight = getHeaderHeight();
          $("html, body").animate({
              scrollTop: target.offset().top - headerHeight - 60
          }, 200);
      }
  });

  $(window).on("resize", function () {
      getHeaderHeight();
  });
});
